import { createContext } from 'react';

export const i18n = createContext({});
export const I18nProvider = i18n.Provider;
export const I18nConsumer = i18n.Consumer;
